import React from 'react'
import { css } from '@emotion/core'
import { DonutChartCard } from '@/components/molecules/survey/donut-chart'
import { BarChartCard } from '@/components/molecules/survey/bar-chart'
import { SurveyStatisticsResponse, ChoiceDistribution, ScoreDistribution } from '@/models/survey/statistics'

/**
 * 集計ページの質問セクションコンポーネント
 * 得点式質問（ドーナツチャート）と選択式質問（バーチャート）を表示
 */
type Props = {
  statistics: SurveyStatisticsResponse | null
}

export const SurveySummaryQuestions: React.FC<Props> = ({ statistics }) => {
  // 選択式、もしくは得点式のデータのみを集約
  const scoreAndChoiceAnswers =
    statistics?.statistics?.filter(
      stat => (stat.type === 'score' || stat.type === 'choice_single' || stat.type === 'choice_multiple') && stat.distribution,
    ) || []

  // データがない場合でも空のコンテナを表示（売上管理画面に合わせる）
  if (!scoreAndChoiceAnswers?.length) {
    return null
  }

  return (
    <div css={questionCardContainerStyle}>
      {/* Satisfaction Donut Charts */}
      {scoreAndChoiceAnswers.map(stat =>
        // 得点式の質問はドーナツチャートで表示
        stat.type === 'score' ? (
          <DonutChartCard key={stat.questionId} title={stat.title} distribution={stat.distribution as ScoreDistribution} />
        ) : // 選択式の質問はバーチャートで表示
        stat.type === 'choice_single' || stat.type === 'choice_multiple' ? (
          <BarChartCard key={stat.questionId} title={stat.title} distribution={stat.distribution as ChoiceDistribution} />
        ) : null,
      )}
    </div>
  )
}

const questionCardContainerStyle = css({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '16px',
  padding: '24px 32px',
  backgroundColor: '#FFF',
  minWidth: '1000px',
})
